import {
  MantineComponent,
  Title,
  Text as MantineText,
  type TextProps as MantineTextProps
} from '@mantine/core'
import { ReactNode } from 'react'
import { cn, checkText, CheckTProps } from '@packages/ui/utils'

export type TypographyProps = MantineComponent<any> &
  CheckTProps & {
    children: string | ReactNode
    className?: string
  }

export const H1 = ({ className, ...props }: TypographyProps) => (
  <Title
    {...props}
    order={1}
    className={cn(
      'm-0 flex items-center gap-4 p-0 py-2 text-3xl font-thin text-inherit sm:text-4xl',
      className
    )}
  >
    {checkText(props)}
  </Title>
)

export const H2 = ({ className, ...props }: TypographyProps) => (
  <Title
    {...props}
    order={2}
    className={cn(
      'm-0 flex items-center gap-3 p-0 py-2 text-2xl font-thin sm:text-3xl',
      className
    )}
  >
    {checkText(props)}
  </Title>
)

export const H3 = ({ className, ...props }: TypographyProps) => (
  <Title
    {...props}
    order={3}
    className={cn(
      'flex items-center gap-4 py-2 text-xl font-thin sm:text-2xl',
      className
    )}
  >
    {checkText(props)}
  </Title>
)

export const Label = ({ className, ...props }: TypographyProps) => (
  <label className={cn('font-bold', className)}>{checkText(props)}</label>
)

type TextProps = MantineTextProps &
  CheckTProps & {
    children: string
  }

export const Text = ({ className, ...props }: TextProps) => {
  return (
    <MantineText className={cn('sc-text text-inhert', className)} {...props}>
      {checkText(props)}
    </MantineText>
  )
}
